// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import MyPlaceRewardsLabel from '@tcp/core/src/components/features/account/PointsClaim/PointsClaim.labels';
import FormPageHeading from '../../../../common/molecule/FormPageHeading';
import internalEndpoints from '../../../../common/internalEndpoints';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
  lblBack,
} from '../../../../../../../utils/labels/globalActions.labels';

export const PointsClaimTopSection = ({ className, onBack }) => {
  const myPlaceRewardsLabel = getLabelFromCopyOrFromTranslation(
    'account.myPlaceRewards',
    MyPlaceRewardsLabel
  );
  return (
    <BodyCopy className={className}>
      <BodyCopy className="elem-mb-LRG">
        <Anchor
          onClick={onBack}
          fontSizeVariation="xlarge"
          anchorVariation="secondary"
          dataLocator="ponints-claim-back"
          className="elem-mb-LRG"
          to={internalEndpoints.pointsHistoryPage.link}
          asPath={internalEndpoints.pointsHistoryPage.path}
        >
          <span className="left-arrow"> </span>
          {renderLabel(
            getLabelFromCopyOrFromTranslation(
              `${GLOBAL_ACTIONS_LABELS}.${lblBack}`,
              GlobalActionsLabels
            ),
            'lbl_back'
          )}
        </Anchor>
      </BodyCopy>
      <FormPageHeading
        className="elem-mb-XL myAccountRightView"
        heading={renderLabel(
          myPlaceRewardsLabel.lbl_points_claim_heading,
          'lbl_points_claim_heading'
        )}
        data-locator="historyPointsLbl"
      />
    </BodyCopy>
  );
};

PointsClaimTopSection.propTypes = {
  labels: PropTypes.shape({}).isRequired,
  onBack: PropTypes.func.isRequired,
  className: PropTypes.string,
};

PointsClaimTopSection.defaultProps = {
  className: '',
};

export default PointsClaimTopSection;
